window.$ = window.jQuery;
$(document).ready(function () {
        $(window).scroll(function () {
            var scrollTop = $(document).scrollTop();
            if (scrollTop > 129) {
                $('.js-main-menu').addClass('fixed');
            } else {
                $('.js-main-menu').removeClass('fixed');

            }
        })
});
